import { OrganizationKeyName } from "../../../../model/Organization";

export const GET_USER_VOUCHER_LIST_FAIL = "SHOP:GET_USER_VOUCHER_LIST_FAIL";

export const getUserVoucherListFailAction = (
  organization: OrganizationKeyName,
  userId: string
) => ({
  type: GET_USER_VOUCHER_LIST_FAIL as typeof GET_USER_VOUCHER_LIST_FAIL,
  organization,
  userId,
});

export type GetUserVoucherListFailAction = ReturnType<
  typeof getUserVoucherListFailAction
>;
